<template>
  <v-container>
    <v-overlay :value="overlay" color="grey lighten-1" absolute :opacity="0.5">
      <v-progress-circular color="green darken-1" indeterminate size="100">{{
        TextLoader
      }}</v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12" sm="12">
        <base-material-card icon="mdi-note-text-outline" color="info" title="Notas Ventas">
          <v-container>
            <v-row no-gutters>
              <v-col cols="12" sm="6" md="3" lg="4" xl="2">
                <export-button :items="DataItems" :headers="headers" :title="'Notas de venta'" @SaveExcel="SaveExcel"></export-button>
              </v-col>
              <v-col cols="12" sm="6" md="9" lg="8" xl="10">
                <v-layout row wrap justify-end>
                  <v-col cols="12" sm="12" md="5" lg="6" xl="4">
                    <v-select
                      @change="changeDate"
                      :items="BranchOffice"
                      v-model="BranchOfficeId"
                      item-value="id"
                      item-text="name"
                      label="Selecciona Sucursal"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" xl="2">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="4"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="startDate"
                          append-icon="mdi-calendar-multiselect"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @change="changeDate"
                        locale="es"
                        :max="finishDate"
                        color="indigo darken-3"
                        v-model="startDate"
                        @input="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" xl="2">
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="4"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="finishDate"
                          append-icon="mdi-calendar-multiselect"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @change="changeDate"
                        locale="es"
                        :min="startDate"
                        color="indigo"
                        v-model="finishDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-layout>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="px-0 pt-0">
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
                  class="elevation-1"
                  dense
                  :search="search"
                  :loading="loading"
                  :single-select="singleSelect"
                  item-key="folio"
                  :show-select="canEdit"
                  light
                  :loader-height="10"
                  no-data-text="Selecciona una Sucursal"
                  :mobile-breakpoint="600"
                  loading-text="Cargando Datos"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-row>
                        <v-col cols="12" sm="6"></v-col>
                        <v-col>
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.creationDate="{ item }">{{
                    parseDate(item.creationDate)
                  }}</template>
                  <template v-slot:item.totalAmount="{ item }">
                    <strong class="display-1 text-no-wrap">
                      $ {{ parseDecimal(item.totalAmount) }}
                    </strong>
                  </template>
                  <template v-slot:item.attentionTime="{ item }">{{
                    parseDecimal(item.attentionTime)
                  }}</template>
                  <template v-slot:item.action="{ item }">
                    <v-layout justify-space-around>
                      <v-tooltip bottom color="success">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            color="success"
                            @click="onDetail(item.noteId)"
                            v-on="on"
                            >mdi-file-document-edit-outline</v-icon
                          >
                        </template>
                        <span>Ver Detalles</span>
                      </v-tooltip>
                      <v-tooltip bottom color="red">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="canEdit"
                            color="red"
                            @click="onCancel(item.noteId)"
                            v-on="on"
                            >mdi-file-cancel</v-icon
                          >
                        </template>
                        <span>Cancelar Nota</span>
                      </v-tooltip>
                    </v-layout>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                <v-card class="mt-n4 elevation-1">
                  <v-card-title>
                    <v-icon left color="blue darken-3" size="30">
                      mdi-bell-ring
                    </v-icon>
                    <strong class="display-2" style="color: blue">
                      Notas a facturar
                    </strong>
                  </v-card-title>

                  <v-data-table
                    :headers="headers2"
                    :items="selected"
                    class="elevation-1"
                    dense
                    hide-default-footer
                    disable-pagination
                    :calculate-widths="true"
                    :loader-height="10"
                    :mobile-breakpoint="600"
                    :fixed-header="true"
                    :sort-by="['folio']"
                    :sort-desc="[true]"
                  >
                    <template v-slot:top>
                      <v-container>
                        <v-autocomplete
                          :items="BillingClient"
                          v-model="clientBilling"
                          item-text="name"
                          item-value="id"
                          class="title"
                          outlined
                          clearable
                          label="Cliente facturacion"
                          @input="$v.clientBilling.$touch()"
                          @blur="$v.clientBilling.$touch()"
                          :error-messages="clientBillingErrors"
                          placeholder="Buscar..."
                        >
                        </v-autocomplete>
                      </v-container>
                    </template>

                    <template v-slot:item.day="{ item }">{{
                      parseDate(item.creationDate)
                    }}</template>
                    <template v-slot:item.totalAmount="{ item }">
                      <strong style="color: blue" class="text-no-wrap">
                        $ {{ parseDecimal(item.totalAmount) }}
                      </strong>
                    </template>

                    <template v-slot:item.options="{ item }">
                      <v-tooltip color="red" bottom>
                        <template v-slot:activator="{on}">
                          <v-icon color="red" @click="DeleteInvoice(item)" v-on="on">
                            mdi-close
                          </v-icon>
                        </template>
                        <span>Quitar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  <v-card-actions>
                    <v-container>
                      <v-row>
                        <v-col class="pa-0">
                          <v-textarea
                            v-model="observations"
                            background-color="grey lighten-4"
                            name="input-7-1"
                            outlined
                            row="1"
                            auto-grow
                            counter
                            maxlength="240"
                            prepend-icon="mdi-comment"
                            label="Puede esctibir aquí sus Observaciones/Comentarios"
                            hint="Escriba aquí"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pa-0 d-flex justify-center">
                          <v-btn
                            v-if="canEdit"
                            color="indigo darken-3"
                            outlined
                            title
                            @click="MakeBilling()"
                          >
                            Facturar
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
    <modal-details :dialog="seeDetails" @Close="seeDetails = false">
    </modal-details>
    <generate-invoice
      :dataVal="dataVal"
      :generate="generate"
      @Success="Success"
      @ErrorOcurred="ErrorOcurred"
    ></generate-invoice>

    <v-snackbar
      v-model="snack"
      multi-line
      top
      right
      :timeout="3200"
      :color="color"
    >
      <v-icon color="white" size="30">{{ icon }} </v-icon> {{ text }}
      <v-icon right color="white" @click="snack = false"> mdi-close </v-icon>
    </v-snackbar>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import axios from 'axios'
  import XLSX from 'xlsx'
  import * as _ from 'lodash'

  import * as jsPDF from 'jspdf'
  import 'jspdf-autotable'

  import { mapMutations } from 'vuex'
  import Swal from 'sweetalert2'
  export default {
    components: {
      ExportButton: () => import('../../Export/ExporTest'),
      ModalDetails: () => import('../modals/details'),
      GenerateInvoice: () => import('../invoices/generate'),
    },
    mixins: [validationMixin],
    validations: {
      clientBilling: { required },
    },
    data: () => ({
      canEdit: false,
      snack: false,
      color: '',
      icon: '',
      text: '',
      observations: '',
      overlay: false,
      TextLoader: 'Facturando',
      dataVal: null,
      generate: false,
      _bussinesAccountId: null,
      selected: [],
      singleSelect: false,
      seeDetails: false,
      DataItems: [],
      items: [],
      BranchOfficeId: null,
      menu: false,
      search: null,
      menu1: false,
      loading: false,
      startDate: moment().format('YYYY-MM-DD'),
      finishDate: moment().format('YYYY-MM-DD'),
      dateMax: moment().format('YYYY-MM-DD'),
      headers: [
        {
          text: 'Folio',
          value: 'folio',
        },
        {
          text: 'Fecha',
          value: 'creationDate',
        },
        {
          text: 'Oficina',
          value: 'branchOffice',
          align: 'left',
        },
        {
          text: 'Cliente',
          value: 'client',
          align: 'left',
        },
        {
          text: 'Empleado',
          value: 'employee',
          align: 'left',
        },
        {
          text: 'Monto',
          value: 'totalAmount',
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
          align: 'right',
        },
      ],
      headers2: [
        {
          value: 'folio',
          text: 'Folio',
          align: 'left',
        },
        {
          text: 'Cliente',
          value: 'client',
          align: 'left',
        },
        {
          value: 'day',
          text: 'Fecha',
          align: 'left',
        },
        {
          value: 'totalAmount',
          text: 'Monto',
          align: 'right',
        },
        {
          value: 'options',
        },
      ],
      clientBilling: null,
      BillingClient: [],
      clientBillingId: null,
      regimenClient: "",
      regimenBusiness: "",
      // items2:[],
    }),
    computed: {
      ReloadNotes: {
        get: function () {
          return this.$store.state.ReloadNotes
        },
        set: function (val) {
          this.Set_reload(val)
        },
      },
      clientBillingErrors () {
        const errors = []
        if (!this.$v.clientBilling.$dirty) return errors
        !this.$v.clientBilling.required &&
          errors.push(this.$t('errors.required'))
        return errors
      },
      BranchOffice () {
        var items = _.cloneDeep(this.$store.state.BranchOffice)
        items.unshift({ id: 0, name: 'Todas las Sucursales' })
        return items
      },
    },
    watch: {
      BranchOfficeId (val) {
        if (val != null) {
          this.getNotes(this.startDate, this.finishDate, this.BranchOfficeId)
        }
      },
      clientBilling (val) {
        if (val != null) {
          axios.get(`/api/Clients/${val}`, {
            headers: {
              bussinessId: localStorage.getItem('_bussinessAccountId'),
            },
          }).then(result => {
            const data = result.data
            this.clientBillingId = data.billingData[0].id
            /*    if(this.clientBillingId!==null) {

              }else {
                this.clientBillingId = data.id;
              } */
            //  alert(this.clientBillingId)
          }).catch(err => {
            console.log(err)
          })
        }
        // alert(val)
      },
      ReloadNotes (val) {
        if (val && this.BranchOfficeId != null) {
          this.getNotes(this.startDate, this.finishDate, this.BranchOfficeId)
        }
      },
    },
    created () {
      const v = this.BranchOffice
      if (v.length === 0) {
        this.LoadBranch()
      }
      this._bussinesAccountId = localStorage.getItem('_bussinessAccountId')
      this.getClients()
      this.GetPermissionUser()
    },
    methods: {
      GetPermissionUser () {
        this.canEdit = _.find(
          _.find(this.$store.state.permissions, e => e.id === 1).submodules,
          e => e.submodule.id === 28
        ).editAllowed
      },
      ...mapMutations({
        Set_reload: 'SET_RELOADNOTES',
        SetBranh: 'SET_BRANCH',
      }),
      LoadBranch () {
        let bussinessAccountId = localStorage.getItem('_bussinessAccountId')
        axios.get(`/api/BranchOffice/GetByAccount/${bussinessAccountId}`).then(result => {
          this.SetBranh(result.data)
        }).catch(error => {
          console.log(error)
        })
      },
      ErrorOcurred () {
        this.generate = false
        this.snack = true
        this.color = 'orange'
        this.icon = 'mdi-check-circle'
        this.text = 'Factura timbrada pero no se pudo generar el PDF'
      },
      Success () {
        this.generate = false
        this.snack = true
        this.color = 'green'
        this.icon = 'mdi-check-circle'
        this.text = 'Exito al Generar la(s) facturas'
      },
      DeleteInvoice (item) {
        const index = this.selected.indexOf(item)
        this.selected.splice(index, 1)
      },
      getClients () {
        axios.get('/api/Clients', {
          headers: {
            bussinessId: localStorage.getItem('_bussinessAccountId'),
          },
        }).then(result => {
          this.BillingClient = result.data;
        }).catch(err => {
          console.log(err)
        })
      },
      MakeBilling () {
        this.$v.$touch()
        if (this.$v.clientBilling.required) {
          if (this.selected.length > 0) {
            this.overlay = true
            let notes = []
            _.map(this.selected, o => {
              notes.push(o.noteId)
            })
            axios.post('/api/Invoices', { notes: notes, comments: this.observations, clientBillingId: this.clientBillingId }, {
              headers: {
                bussinessId: this.$store.state._bussinessAccountId,
              },
            }).then(result => {
              this.overlay = false
              this.generate = true
              this.dataVal = result.data
              this.observations = ''
              this.selected = []
              this.clientBilling = null
              this.$v.$reset()
              // console.log(result)
            }).catch(() => {
              this.overlay = false
              this.snack = true
              this.color = 'red'
              this.text = 'Error al generar la factura'
              this.icon = 'mdi-alert-circle'
            })
            // console.log(notes)
          } else {
            alert('Debes seleccionar uno o mas notas a facturar')
          }
        } else {
          this.overlay = false
          this.snack = true
          this.color = 'red'
          this.text = 'Los campos en rojo son obligatoríos'
          this.icon = 'mdi-alert-circle'
        }
      },
      SaveExcel () {
        let data_ = []
        this.DataItems.forEach(e => {
          data_.push({
            day: moment(e.day).format('YYYY-MM-DD'),
            journalId: e.journalId,
            folio: e.folio,
            branchOffice: e.branchOffice,
            employee: e.employee,
            totalAmount: e.totalAmount,
          })
        })
        let data = XLSX.utils.json_to_sheet(data_, {
          header: [`day`, `journalId`, `folio`, `employee`, `totalAmount`],
        })
        data[`A1`].v = 'Fecha'
        data[`B1`].v = 'Turno'
        data[`C1`].v = 'Folio'
        data[`D1`].v = 'Empleado'
        data[`D1`].v = 'Monto'

        const workbook = XLSX.utils.book_new()
        const filename = 'Notas-de-venta'
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      },
      parseDecimal (val) {
        return `${Number(parseFloat(val).toFixed(2)).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        })}`
      },
      parseDate (val) {
        return moment(val).format('YYYY-MM-DD hh:mm a')
      },
      changeDate () {
        // console.log(this.BranchOfficeId);
        this.getNotes(this.startDate, this.finishDate, this.BranchOfficeId)
      },
      onDetail (id) {
        let products = []
        let taxes = []
        axios.get(`/api/Notes/Notes/${id}`, {
          headers: {
            bussinessId: localStorage.getItem('_bussinessAccountId'),
          },
        }).then(result => {
          products = []
          taxes = []
          // client = Object.assign({},result.client);
          // console.log()
          const data = result.data.details;
          _.map(data, (e, index) => {
            products.push({
              product: e.product,
              quantity: e.quantity,
              subtotal: Number(parseFloat(e.subtotal).toFixed(2)),
              taxes: Number(parseFloat(e.taxes).toFixed(2)),
              unitPrice: e.unitPrice,
              totalPrice: e.totalPrice,
              taxesDetail: e.taxesDetail,
            })
            _.map(e.taxesDetail, f => {
              taxes.push({
                alias: f.alias,
                percent: f.percent,
                totalAmount: Number(f.totalAmount).toFixed(2),
              })
            })
          })
          this.PrintTicket(products, taxes, id, result.data.client, result.data.observations)
        }).catch(error => {
          console.log(error)
        })
      },
      PrintTicket (products, taxes, id, client, observations) {
        let subtotal = 0
        let descuentos = 0
        let impuestos = 0
        let total = 0

        subtotal = _.sumBy(products, e => {
          return e.subtotal
        })
        impuestos = _.sumBy(products, e => {
          return e.taxes
        })

        total = Number(subtotal) + Number(impuestos)

        var doc = new jsPDF(('p', 'mm', 'a3'))
        const file = this.$store.state._logoBussinnes
        const bussinesName = this.$store.state._titleBussines

        // #region Header
        doc.setFontSize(16)
        doc.setFontStyle('bold')
        doc.setFontSize(10)
        doc.text(`${bussinesName}, Sucursal ${client ? client.branchOffice : ''}`, 20, 20)
        doc.text(`FOLIO: ${id}`, 20, 30)
        doc.setFontSize(9)
        doc.setFontStyle('normal')
        doc.text('Hermosillo, Sonora', 200, 20, null, null, 'right')
        doc.text(
          "Fecha.: " + moment().format("DD/MM/YYYY hh:mm:ss a"),
          200,
          25,
          null,
          null,
          "right"
        )
      doc.text(
        `E-Mail: ${this.$store.state._email}`,
        200,
        30,
        null,
        null,
        "right"
      );
      doc.setFontStyle("bold");

      doc.setLineWidth(0.2);
      doc.line(10, 35, 200, 35);

      doc.text("DATOS DE CLIENTE", 100, 40, null, null, "center");

      doc.setFontStyle("normal");

      doc.text(`Cliente: ${client ? client.name : ''} ${client ? client.lastName : ''}`, 20, 45);
      /*         this.addresEmisor = 'Mazatlan, 732 villa fontana, '*/
      doc.text(
        `Fecha de nota: ${moment(client ? client.creationDate : '')
          .subtract(7, "hours")
          .format("DD/MM/YYYY hh:mm:ss a")}`,
        200,
        45,
        null,
        null,
        "right"
      );
      doc.text(
        `Lugar: ${client ? client.city : ''}, ${client ? client.state : ''}, ${client ? client.country : ''}`,
        20,
        50
      );
      doc.text(
        `Tel. ${client ? client.phone : ''}, Cel. ${client ? client.celPhone : ''}`,
        200,
        50,
        null,
        null,
        "right"
      );

      doc.text(`Correo cliente: ${client ? client.email : ''}`, 20, 55);

      //#endregion

      //#region Line
      doc.setDrawColor(63, 103, 132);
      doc.setLineWidth(0.5);
      doc.line(10, 60, 200, 60);
      //#endregion

      //#region  Table
      var columns = [
        {
          title: "PRODUCTO",
          dataKey: "product"
        },
        {
          title: "CANT.",
          dataKey: "quantity"
        },
        {
          title: "P.U",
          dataKey: "unitPrice"
        },
        {
          title: "Impuestos",
          dataKey: "taxes"
        },
        {
          title: "Subtotal",
          dataKey: "subtotal"
        }
      ];

      let rows_ = _.cloneDeep(products);
      _.map(rows_, e => {
        e.product = e.product;
        e.quantity = e.quantity;
        e.unitPrice = `$ ${Number(e.unitPrice).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        e.taxes = `$ ${Number(e.taxes).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        e.subtotal = `$ ${Number(e.subtotal).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
      });

      doc.autoTable(columns, rows_, {
        theme: "grid",
        startY: 70,
        margin: 2,
        tableWidth: 205,
        pageBreak: "avoid",
        rowPageBreak: "auto",
        bodyStyles: { valign: "top" },
        styles: {
          fontSize: 9
        },
        headStyles: {
          halign: "center",
          valign: "middle",
          fillColor: [155, 155, 155]
        },
        didParseCell: enhanceWordBreak
      });

      let EndY = doc.autoTable.previous.finalY + 10;

      doc.setFillColor(255, 255, 200);
      doc.rect(1, EndY - 5, 60, 6, "F");

      var columnTaxes = [
        {
          title: "TIPO",
          dataKey: "alias"
        },
        {
          title: "TASA",
          dataKey: "percent"
        },
        {
          title: "$",
          dataKey: "totalAmount"
        }
      ];

      let rowsTrasladados = _.cloneDeep(taxes); //[]; //this.trasladados;
      rowsTrasladados = _(rowsTrasladados).groupBy('alias')
      .map((array, alias) => ({
        alias,
        percent: `${Number(array[0].percent) * 100}%`,
        totalAmount: _.sumBy(array,e => Number(e.totalAmount))
      })).value();
      _.map(rowsTrasladados, e => {
        e.alias = e.alias;
        e.percent = e.percent;
        e.totalAmount = `$ ${Number(e.totalAmount).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
      });

      doc.setFontSize(10);
      doc.text("Impuestos", 10, EndY, null, null, "left");

      doc.autoTable(columnTaxes, rowsTrasladados, {
        startY: EndY + 3, //{left:1},
        showHead: "firstPage",
        tableWidth: 60,
        styles: {
          fontSize: 9,
          overflow: "hidden"
        },
        headStyles: {
          halign: "center",
          valign: "middle",
          fillColor: [155, 155, 155]
        },
        columnStyles: {
          Importe: { halign: "right" },
          TasaOCuota: { halign: "center" }
        },
        didParseCell: enhanceWordBreak,
        margin: { right: 107, left: 1 }
      });
      //#endregion

      doc.setFillColor(255, 255, 200);
      doc.rect(130, EndY - 5, 75, 6, "F");
      doc.text("General", 160, EndY, null, null, "left");

      doc.setFontStyle("normal");

      doc.text("SUBTOTAL", 130, EndY + 5, null, null, "left");
      subtotal = "$ " + parseFloat(subtotal).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2});
      doc.text(subtotal, 170, EndY + 5, null, null, "left");

      doc.setFillColor(220, 220, 220);
      doc.rect(130, EndY + 7, 75, 6, "F");
      doc.text("DESCUENTO", 130, EndY + 11, null, null, "left");
      descuentos = "$ " + parseFloat(descuentos).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2});
      doc.text(descuentos, 170, EndY + 11, null, null, "left");
      doc.text("IMPUESTOS", 130, EndY + 17, null, null, "left");
      impuestos = "$ " + parseFloat(impuestos).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2});
      doc.text(impuestos, 170, EndY + 17, null, null, "left");

      /*     doc.setFillColor(220, 220, 220);
        doc.rect( 130,EndY+18, 75, 6, 'F');
            doc.text('RETENIDOS',130, EndY + 22, null,null,'left')
              const retenidos = '$ ' + 0 //parseFloat(this.impuestosRetenidos).toFixed(2);
              doc.text(retenidos,170,EndY + 22,null,null,'left') */

      doc.setFontStyle("bold");
      doc.setFontSize(13);

      doc.setProperties({
        title: `Nota de venta ${id}`,
        subject: "",
        author: "",
        keywords: "generated, pdf, web 2.0, pos2020, pos-2020,2020",
        creator: "Get-element"
      });

      doc.text("TOTAL", 130, EndY + 30, null, null, "left");
      total = "$ " + parseFloat(total).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2});
      doc.text(total, 170, EndY + 30, null, null, "left");

      EndY += 35;
      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.setFillColor(255, 255, 200);
      doc.rect(1, EndY, 120, 6, "F");
      doc.text("Comentarios", 10, EndY + 5, null, null, "left");
      EndY += 5;
      doc.text(observations ? observations : 'Sin comentarios', 5, EndY + 5, {maxWidth: 100});
      const pages = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.width; //Optional
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(10);

      for (let j = 1; j < pages + 1; j++) {
        let horizontalPos = pageWidth / 2; //Can be fixed number
        let verticalPos = pageHeight - 10; //Can be fixed number
        doc.setPage(j);

        doc.text("Pagina " + j + " de " + pages, horizontalPos, verticalPos, {
          align: "center"
        }); //Optional text styling});
      }

      doc.autoPrint();
      window.open(doc.output("bloburl"));

      function enhanceWordBreak({ doc, cell, column }) {
        if (cell === undefined) {
          return;
        }
        const hasCustomWidth = typeof cell.styles.cellWidth === "number";

        if (hasCustomWidth || cell.raw == null || cell.colSpan > 1) {
          return;
        }

        let text;

        if (cell.raw instanceof Node) {
          text = cell.raw.innerText;
        } else {
          if (typeof cell.raw == "object") {
            // not implemented yet
            // when a cell contains other cells (colSpan)
            return;
          } else {
            text = "" + cell.raw;
          }
        }

        // split cell string by spaces
        // const words = text.split(/\s+/);
        const words = text.split(/\s+|(?<=-)/);
        // calculate longest word width
        const maxWordUnitWidth = words
          .map(s => Math.floor(doc.getStringUnitWidth(s) * 100) / 100)
          .reduce((a, b) => Math.max(a, b), 0);
        const maxWordWidth =
          maxWordUnitWidth * (cell.styles.fontSize / doc.internal.scaleFactor);

        const minWidth = cell.padding("horizontal") + maxWordWidth;

        // update minWidth for cell & column

        if (minWidth > cell.minWidth) {
          cell.minWidth = minWidth;
        }

        if (cell.minWidth > cell.wrappedWidth) {
          cell.wrappedWidth = cell.minWidth;
        }

        if (cell.minWidth > column.minWidth) {
          column.minWidth = cell.minWidth;
        }

        if (column.minWidth > column.wrappedWidth) {
          column.wrappedWidth = column.minWidth;
        }
      }
    },

    onCancel(id) {
      // console.log(id);
      Swal.fire({
        title: "Confirme la cancelación",
        text: "¿Desea cancelar eata nota ?",
        type: "warning",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          Swal.fire({
            title: "Espere"
          });
          Swal.showLoading();
          axios
            .delete(`api/Sales/Note/${id}`, {
              headers: {
                bussinessId: localStorage.getItem("_bussinessAccountId")
              }
            })
            .then(result => {
              Swal.fire("Exito", "Nota cancelada con exito", "success");
              this.getNotes(
                this.startDate,
                this.finishDate,
                this.BranchOfficeId
              );
              const indexOf = this.DataItems.findIndex(i => i.id == id);
              this.DataItems.splice(indexOf, 1);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    getNotes(startDate, finishDate, branchOfficeId) {
      if (branchOfficeId != null) {
        this.loading = true;
        axios
          .post(
            `/api/Sales/Notes`,
            {
              startDate: startDate,
              finishDate: finishDate,
              branchOfficeId: branchOfficeId == 0 ? null : branchOfficeId
            },
            {
              headers: {
                bussinessId: this._bussinesAccountId
              }
            }
          )
          .then(result => {
            this.Set_reload(false);
            setTimeout(() => {
              this.DataItems = [];
              this.items = result.data;
              this.loading = false;
              _.map(this.items, e => {
                this.DataItems.push({
                  id: e.id,
                  day: moment(e.day).format("YYYY-MM-DD"),
                  journalId: e.journalId,
                  folio: e.folio,
                  branchOffice: e.branchOffice,
                  employee: e.employee,
                  totalAmount: e.totalAmount,
                  attentionTime: e.attentionTime
                });
              });
            }, 1000);
          })
          .catch(err => console.log(err));
      } else {
        this.snack = true;
        this.color = "red";
        this.icon = "mdi-alert";
        this.text = "Selecciona una sucursal";
      }
    }
  }
};
</script>
